import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { PhxTooltipModule } from 'phx-core';

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MapComponent } from './map.component';
import { MapMarkerDirective } from './marker.directive';
import { CurrentLocationMarkerDirective } from './current-location-marker.directive';
import { CurrentLocationMarkersListDirective } from './current-location-markers-list.directive';
import { MapPolylineDirective } from './polyline.directive';
import { MapPolygonDirective } from './polygon.directive';
import { MapControlDirective } from './control.directive';
import { SearchPlacesDirective } from './search-places.directive';
import { GeofenceDrawingToolComponent } from './geofence-drawing-tool.component';
import { CommonComponentsModule } from '../common-components/module';
import { FormsModule } from '@angular/forms';

const COMPONENTS = [
  MapComponent,
  MapMarkerDirective,
  MapPolylineDirective,
  MapPolygonDirective,
  MapControlDirective,
  CurrentLocationMarkerDirective,
  CurrentLocationMarkersListDirective,
  SearchPlacesDirective,
  GeofenceDrawingToolComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CommonComponentsModule,
    PhxTooltipModule,
    NzFormModule,
    NzInputModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class MapModule {}
